module.exports = __webpack_public_path__ + "img/filter.f1b92664.svg";